import { useState, type FormEvent, type KeyboardEvent } from 'react';
import { Send, Square, Zap, Brain } from 'lucide-react';
import { useBrain } from '../../contexts/BrainContext';

export function ChatInput() {
  const { sendMessage, pending, stop, model, setModel } = useBrain();
  const [value, setValue] = useState('');

  const handleSubmit = (e?: FormEvent) => {
    e?.preventDefault();
    if (!value.trim() || pending) return;
    sendMessage(value.trim());
    setValue('');
  };

  const handleKey = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2 border-t border-white/10 bg-neutral-950/80 px-3 py-2.5 backdrop-blur">
      <div className="flex items-center gap-1 text-[11px]">
        <button
          type="button"
          onClick={() => setModel('claude-sonnet-4-6')}
          className={`flex items-center gap-1 rounded-md px-2 py-0.5 transition ${
            model === 'claude-sonnet-4-6'
              ? 'bg-brand-500/15 text-brand-200'
              : 'text-neutral-500 hover:bg-white/5 hover:text-neutral-300'
          }`}
          title="Sonnet — best reasoning"
        >
          <Brain className="h-3 w-3" /> Sonnet
        </button>
        <button
          type="button"
          onClick={() => setModel('claude-haiku-4-5-20251001')}
          className={`flex items-center gap-1 rounded-md px-2 py-0.5 transition ${
            model === 'claude-haiku-4-5-20251001'
              ? 'bg-emerald-500/15 text-emerald-200'
              : 'text-neutral-500 hover:bg-white/5 hover:text-neutral-300'
          }`}
          title="Haiku — cheaper, faster, less nuanced"
        >
          <Zap className="h-3 w-3" /> Haiku
        </button>
      </div>
      <div className="flex items-end gap-2">
        <textarea
          rows={2}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKey}
          placeholder="Ask the Brain anything about your deals, inspectors, suburbs…"
          className="input-control flex-1 resize-none text-sm"
        />
        {pending ? (
          <button type="button" onClick={stop} className="btn-secondary !rounded-xl px-3" title="Stop">
            <Square className="h-4 w-4" />
          </button>
        ) : (
          <button type="submit" disabled={!value.trim()} className="btn-primary !rounded-xl px-3" title="Send (Enter)">
            <Send className="h-4 w-4" />
          </button>
        )}
      </div>
    </form>
  );
}
